export default {
  twilioToken: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/app/state.js